// =====================================
//
//   CMS 
//   Author: Gray
//   createtime: 2016 / 11 / 07
//
// =====================================
window.InifECMobileApp.controller("CMSDesignerController", ['$scope', '$stateParams', '$rootScope', 'CMSService', '$PreviousState',
    function($scope, $stateParams, $rootScope, CMSService, $PreviousState) {

        // --------------------------------
        // 取得更多設計師的案例資訊
        // --------------------------------
        var loadMoreList = function() {

            if($scope.isShowDesignerInfo || $scope.isLoadingList || $scope.isEmpty || $scope.isNoMore) {
                return;
            }

            getDesignerProjectPost();
        }

        // --------------------------------
        // 上一頁
        // --------------------------------
        var goBack = function() {
            
            var backState = $PreviousState.getLastState();

            if(backState == undefined) {
                backState = {
                    name: window.STATES.DESIGNER_LIST,
                    params: {}
                };
            }
            
            $PreviousState.goBack(backState);
        }

        // --------------------------------
        // [private] 取得設計師資訊
        // --------------------------------
        var getDesigner = function() {

            if($scope.isLoading || !$scope.slug) {
                return;
            }

            $scope.isLoading = true;

            CMSService.getDesigner($scope.slug).then(function(result) {

                if(result) {
                    $scope.designer = result;
                } else {
                    $scope.isError = true;
                }

                $scope.isLoading = false;

                getDesignerProjectPost();

            }, function(error) {

                $scope.isLoading = false;
                $scope.isError = true;
            })
        }

        // --------------------------------
        // [private] 取得設計師的案例資訊
        // --------------------------------
        var getDesignerProjectPost = function() {

            if($scope.isLoadingList) {
                return;
            }

            $scope.isLoadingList = true;

            CMSService.getDesignerProjectPost($scope.designer._id, $scope.page).then(function(result) {

                if(result) {
                    if(Array.isArray(result.results) && result.results.length > 0) {
                        Array.prototype.push.apply($scope.designerPostList, result.results);
                    } else if($scope.designerPostList.length > 0) {
                        $scope.isNoMore = true;
                    } else if($scope.designerPostList.length == 0) {
                        $scope.isEmpty = true;
                    }
                }

                $scope.page++;
                $scope.isLoadingList = false;
            });
        }

        var showDesignerInfo = function(isShowDesignerInfo) {

            $scope.isShowDesignerInfo = isShowDesignerInfo;
        }

        // --------------------------------
        // [private] 初始化
        // --------------------------------
        var init = function() {

            getDesigner();
        }

        //==========================
        //  Events
        //==========================
        $scope.$on("$stateChangeSuccess", function(event, toState, toParams, fromState, fromParams) {

            if(fromState.name == window.STATES.PROJECT_LIST) {
                $scope.backParams = fromParams;
            } else {
                $scope.backParams = undefined;
            }
        });

        //==========================
        //  Members
        //==========================
        $scope.slug = $stateParams.slug;
        $scope.page = 1;
        $scope.designer;
        $scope.designerPostList = [];
        $scope.backParams = undefined;
        $scope.isShowDesignerInfo = false;
        $scope.isLoading = false;
        $scope.isLoadingList = false;
        $scope.isNoMore = false;
        $scope.isEmpty = false;

        //==========================
        //  Methods
        //==========================
        $scope.loadMoreList = loadMoreList;
        $scope.goBack = goBack;
        $scope.showDesignerInfo = showDesignerInfo;

        //==========================
        //  Init
        //==========================
        init();
    }
]);